import apiCreator from './util/ApiCreator';
const api = apiCreator('/api/dealer-portal/orders');

export default {

    get (orderId){
        return api.get(`/${orderId}`);
    },

    authorize (orderId, statusId) {
        return api.patch(`/${orderId}/authorize/${statusId}`);
    },

    cancel(orderId){
        return api.patch(`/${orderId}/cancel`);
    },

    updateShippingAddress (orderId, address){
        return api.patch(`/${orderId}/shipping-address`, address);
    },

    updateItemShippingAddress (orderId, orderItemId, address){
        return api.patch(`/${orderId}/items/${orderItemId}/shipping-address`, address);
    },

    updateBillingAddress(orderId, address){
        return api.patch(`/${orderId}/billing-address`, address);
    },

    create (context) {
        return api.post('/', context);
    },

    sampleInvoice (context) {
        return api.post('/sample-invoice', context);
    },

    getSavedAddresses () {
        return api.get('/addresses');
    },

    deleteAddress (id) {
        return api.delete(`/addresses/${id}`);
    },
}
